














import Vue from "vue";
export default Vue.extend({
  name: "Box",
  props: {
    title: {
      type: String,
      required: true
    },
    requiredFiles: {
      type: Array,
      required: true,
      validator: (value: Array<string>) => value.length === 2
    }
  }
});
